<div class="rule-creation-chat">
  <!-- Starting state -->
  <div *ngIf="isStarting" class="chat-status">
    <p-progressSpinner styleClass="chat-spinner" />
    <span>Démarrage de la session&hellip;</span>
  </div>

  <!-- Error banner -->
  <p-message
    *ngIf="error"
    severity="error"
    [text]="error"
    styleClass="chat-error"
  />

  <!-- Chat body -->
  <ng-container *ngIf="!isStarting">
    <!-- Artifact progress indicator -->
    <div *ngIf="artifacts.length > 0" class="chat-step-indicator">
      <span class="step-label">Progression :</span>
      <span class="step-value"
        >{{ resolvedArtifactCount }} / {{ artifacts.length }} artéfacts
        résolus</span
      >
      <p-tag
        *ngIf="isCompleted"
        severity="success"
        value="Complété"
        styleClass="step-tag"
      />
    </div>

    <!-- Rule created notice -->
    <div *ngIf="createdRuleId" class="chat-rule-created">
      <i class="pi pi-check-circle"></i>
      Règle créée avec succès &mdash; ID : <strong>{{ createdRuleId }}</strong>
    </div>

    <!-- Messages -->
    <div #messagesContainer class="chat-messages">
      <div
        *ngFor="let msg of messages; trackBy: trackByIndex"
        class="chat-message"
        [ngClass]="msg.role"
      >
        <div class="message-bubble">
          <span class="message-role">{{
            msg.role === "user" ? "Vous" : "Assistant"
          }}</span>
          <div
            *ngIf="msg.role === 'assistant'"
            class="message-content markdown-content"
            [innerHTML]="renderMarkdown(msg.content)"
          ></div>
          <p *ngIf="msg.role === 'user'" class="message-content">
            {{ msg.content }}
          </p>

          <!-- Streaming indicator -->
          <span *ngIf="msg.isStreaming" class="streaming-cursor">&#9646;</span>

          <!-- Structured choices -->
          <div *ngIf="msg.choices && !msg.isStreaming" class="message-choices">
            <p class="choices-prompt">{{ msg.choices.prompt }}</p>
            <div class="choices-buttons">
              <button
                *ngFor="let option of msg.choices.options"
                pButton
                type="button"
                class="p-button-outlined choice-btn"
                [title]="option.description || option.label"
                (click)="selectChoice(option.id, option.label)"
                [disabled]="isLoading"
              >
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="sessionId && messages.length === 0" class="chat-empty">
        <p>Session démarrée. En attente de la réponse de l'assistant&hellip;</p>
      </div>
    </div>

    <!-- Input area (fixed at bottom) -->
    <div *ngIf="sessionId" class="chat-input-area">
      <div class="p-inputgroup w-full">
        <input
          pInputText
          type="text"
          [(ngModel)]="inputText"
          placeholder="Tapez votre message&hellip;"
          [disabled]="isLoading"
          (keydown.enter)="sendMessage()"
          class="chat-input"
        />
        <button
          pButton
          type="button"
          icon="pi pi-send"
          [disabled]="!canSend"
          (click)="sendMessage()"
          class="p-button-primary"
        ></button>
      </div>
    </div>
  </ng-container>
</div>
